<template>
    <div class="form-item range-picker">
        <h3>
            <slot></slot>
        </h3>
        <div class="range-box">
            <div class="range-scale">
                <div v-if="model.ticks" v-for="(tick, index) in model.ticks" :style="positionOnRange(tick)">
                    <a @click="model.value = tick">{{ format(tick) }}
                        <template v-if="index == model.ticks.length - 1">+</template>
                    </a>
                </div>
            </div>
            <input type="range"
                   :min="model.min"
                   :max="model.max"
                   :step="model.step"
                   @input="model.done = true"
                   v-model="model.value">
            <div class="range-value-box">
                <div class="range-value"
                     :style="positionOnRange(model.value)">
                    {{ format(model.value) }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RangePicker',
    props: {
        model: {},
    },
    methods: {
        positionOnRange: function (value) {
            var percent = ((this.model.min - value) / (this.model.min - this.model.max)) * 100;
            return {
                // Magic numbers are necessary to keep the label roughly centered with the thumb.
                // Credit to CSS-tricks for the magic numbers: https://css-tricks.com/value-bubbles-for-range-inputs/
                left: `calc(${percent}% + (${8 - percent * 0.15}px))`,
            };
        },
        format: function (value) {
            if (typeof this.model.format == 'function') {
                return this.model.format(value)
            } else {
                return value
            }
        }
    },
};
</script>
